export default __webpack_public_path__ + "static/media/gluten.00f7ad3b.svg";